export function dispatchTabVisiblityEvent(visible: boolean) {
    const e = new CustomEvent("changeTabVisibility", {
        detail: {
            visible,
        },
    });
    window.dispatchEvent(e);
}

export type BackButtonBehavior = "news" | "back" | "close" | "esports";
/**
 * This allows us to control the behavior of the back button.
 * Whether it should work like the browser back button, take us back to the inbox main, or close the inbox
 *
 */
export function dispatchBackButtonConditionSetEvent(
    backButtonBehavior: BackButtonBehavior,
) {
    const e = new CustomEvent("backButtonConditionSet", {
        detail: {
            backButtonBehavior,
        },
    });
    window.dispatchEvent(e);
}

/*
 *
 * Sets the visibility of the back and home buttons
 */
export function dispatchControlButtonVisibilityEvent(visible: boolean) {
    const e = new CustomEvent("changeControlButtonVisibility", {
        detail: {
            visible,
        },
    });
    window.dispatchEvent(e);
}
